
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid2 from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import React from 'react';

const ServiceItem = (props: { children: React.ReactNode; }): React.ReactNode => {
    return <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>{props.children}</Grid2>;
};

export const Certification = () => {
    return <Container sx={{ textAlign: 'center' }}>
        <Typography sx={{ pt: 3 }} variant='h2'>Pieux certifiés CWB</Typography>
        <Box sx={{ pb: 3, display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
            <Box sx={{ flex: { xs: 1, sm: 1 }, padding: 2 }}>
                <Box component='img' sx={{ width: { xs: '120px', sm: '100%' } }} src='images/CWB_certification.jpg' title="Logo - Certification CWB" />
            </Box>
            <Box sx={{ flex: { xs: 1, sm: 6 }, display: 'flex', alignItems: 'center' }}>
                <Typography>
                    Dans le domaine des pieux vissés, la qualité des opérations de soudure constitue un élément primordial. Depuis 70 ans, le CWB (Canadian Welding Board / Bureau canadien de soudage) s’efforce d’assurer la sécurité des structures soudées au Canada grâce à son service de certification. En tant que compagnie certifiée, Les Pieux Protech a démontré sa conformité aux normes canadiennes tel que CSA W47.1 Division 2 (Certification des compagnies de soudage par fusion de l’acier) et à la norme CSA W59 pour ses procédés et mode opératoire de soudage. La certification décernée par le CWB est la preuve que Les Pieux Protech rencontre ou dépasse les normes de l’industrie en matière de soudage.
                </Typography>
            </Box>
        </Box>
    </Container>;
};
